
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.65 47.917c-3.663 4.07-10 4.208-13.838.3L5.192 27.222l-1.28-1.56C-3.833 16.215 2.88 2.014 15.094 2.004l2.74-.002A12.697 12.697 0 0129.22 9.06l.07.143c1.162 2.343 4.536 2.25 5.566-.155A12.33 12.33 0 0145.581 1.59l2.766-.137c12.433 0 19.279 14.452 11.397 24.072l-.655.799-19.438 21.594z"}})])
          )
        }
      }
    